(() => {
if (window.emiveVoiceSearchLoaded) return;
window.emiveVoiceSearchLoaded = true;
const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
let active = null;
const cancel = () => { if (active) { active.cancelled = true; active.rec.abort(); } };
document.addEventListener('click', (event) => {
const button = event.target.closest('[data-emive-voice]');
if (!button) { if (event.target.closest('#headerSearchClose')) cancel(); return; }
const form = button.closest('form');
const input = form.querySelector('[name="q"]');
const status = form.querySelector('[data-voice-status]');
if (!Recognition) { status.textContent = 'Seu navegador não oferece busca por voz. Use o microfone do teclado ou digite sua busca.'; return; }
if (active) { cancel(); return; }
const rec = new Recognition();
const session = { rec, cancelled: false };
active = session;
rec.lang = 'pt-BR'; rec.continuous = false; rec.interimResults = false; rec.maxAlternatives = 1;
let received = false;
let failed = false;
const reset = () => { clearTimeout(timer); button.setAttribute('aria-pressed', 'false'); button.setAttribute('aria-label', 'Pesquisar por voz'); if (active === session) active = null; };
rec.onstart = () => { status.textContent = 'Ouvindo… diga o produto que procura. Toque no microfone para cancelar.'; };
rec.onresult = (e) => {
if (session.cancelled || document.hidden || !button.getClientRects().length) return;
const text = e.results[0][0].transcript.trim();
if (!text) return;
received = true; input.value = text;
input.dispatchEvent(new Event('input', { bubbles: true }));
input.dispatchEvent(new Event('change', { bubbles: true }));
status.textContent = 'Pesquisando: ' + text;
rec.stop();
form.requestSubmit();
};
rec.onerror = (e) => {
failed = true;
const messages = { 'not-allowed': 'Permita o uso do microfone no navegador para pesquisar por voz.', 'service-not-allowed': 'A busca por voz não está disponível neste navegador. Digite sua busca.', 'audio-capture': 'Microfone indisponível. Confira a conexão ou digite sua busca.', 'no-speech': 'Não ouvimos sua voz. Toque no microfone e tente novamente.', 'network': 'Não foi possível conectar a busca por voz. Tente novamente ou digite.' };
status.textContent = session.cancelled ? 'Pesquisa por voz cancelada.' : (messages[e.error] || 'Não foi possível reconhecer sua voz. Tente novamente ou digite.');
reset();
};
rec.onend = () => { if (!received && !failed) status.textContent = session.cancelled ? 'Pesquisa por voz cancelada.' : 'Não ouvimos sua voz. Toque no microfone para tentar novamente.'; reset(); };
const timer = setTimeout(() => { session.cancelled = true; rec.abort(); }, 15000);
button.setAttribute('aria-pressed', 'true'); button.setAttribute('aria-label', 'Cancelar pesquisa por voz');
status.textContent = 'Aguardando o microfone…';
try { rec.start(); } catch (_) { failed = true; status.textContent = 'Não foi possível iniciar o microfone. Tente novamente ou digite.'; reset(); }
});
document.addEventListener('visibilitychange', () => { if (document.hidden) cancel(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape') cancel(); });
window.addEventListener('pagehide', cancel);
})();